export const TEST_ID = {
  confirmDialog: 'confirmDialog',
  cancelButton: 'cancelButton',
  acceptButton: 'acceptButton',
};
